<template>
	<div :id="id" class="panel panel-plain" :class="panelClass">
		<div class="panel-heading">
			<h2 v-if="headingLevel === 2" class="panel-title">
				<template v-if="titleAsLink">
					<font-awesome-icon :icon="iconClass" v-if="!!iconClass"></font-awesome-icon><router-link :to="panelLinkAddress"> {{ title }}</router-link>
				</template>
				<template v-else>
					<font-awesome-icon :icon="iconClass" v-if="!!iconClass"></font-awesome-icon> {{ title }}
				</template>
			</h2>
			<h3 v-else-if="headingLevel === 3" class="panel-title">
				<font-awesome-icon :icon="iconClass" v-if="!!iconClass"></font-awesome-icon> {{ title }}
			</h3>
			<h4 v-else class="panel-title">
				<font-awesome-icon :icon="iconClass" v-if="!!iconClass"></font-awesome-icon> {{ title }}
			</h4>
			<button v-if="buttonIsVisible" 
							class="label label-default"
							@click="clearButton()">
				{{ buttonTitle }}
			</button>
		</div>
		<div class="panel-body" :id="`panel-body-${this.id}`">
			<slot></slot>
		</div>
		<div class="panel-footer" v-if="showFooter">
			<slot name="panel-footer"></slot>
		</div>
	</div>
</template>

<script>
	import '../../imports/fontAwesome.js';
	import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

	export default {
		// id:					Panel id
		// panelClass:	Panel class to overwrite default panel CSS
		// hedingLevel:	Level of heading tag
		// title:				Panel title
		// buttonTitle:	Button title
		// showButton:	Button will display in panel heading if set to true
		// callback:		Name of a parent function that should run
		name: 'PanelPlain',
		props: {
			id: {
				type: String,
				required: true
			},
			panelClass: {
				type: String,
				default: ''
			},
			headingLevel: {
				type: Number,
				default: 2
			},
			title: {
				type: String,
				default: ''
			},
			buttonTitle: {
				type: String,
				default: 'New'
			},
			showButton: {
				type: Boolean,
				default: false
			},
			iconClass: {
				type: String,
				default: ''
			},
			panelLinkAddress: {
				type: String,
				default: ''
			},
			callback: {
				type: Function,
				default() {
					return function(){};
				}
			},
			showFooter: {
				type: Boolean,
				default: false
			},
			titleAsLink: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				buttonIsVisible: this.showButton
			}
		},
		components: {
			FontAwesomeIcon
		},
		methods: {
			clearButton() {
				this.buttonIsVisible = false;
				this.callback();
			}
		}
	}
</script>
